<template>
  <div>
    <navbar class="sticky  pushBack"></navbar>
    <div class="text-center my-5">
      <img src="@/assets/404.svg" alt="Site" style="object-fit: cover" height="50%" width="50%" class="animated bounce infinite">
    </div>
    <div class="text-center animated bounceInDown">
      <span class="h1 mx-4 ">Page Not Found</span>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/navbar.vue'
export default {
  name: 'Error',
  components: {
    Navbar
  }
}
</script>

<style scoped>
.pushBack{
  z-index: 1;
}
</style>
